module.exports = __webpack_public_path__ + "img/PS-M-10.c8863c0a.svg";